import './App.css';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import Dashboard from './components/Dashboard/Dashboard';
import Login from './components/Login/Login';
import Success from './components/Success/Success';
import Error from './components/Error/Error';
import { createContext, useState } from 'react';
import Close from './components/Close/Close';
import HomeControll from './components/HomeControll/HomeControll';


export const idContext = createContext<any | null>(null);

function App() {

  const [id,setId] = useState('');
  
  return (
    <idContext.Provider value={[id,setId]}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeControll />} />
        <Route path="/success" element={<Success />} />
        <Route path="/error" element={<Error />} />
        <Route path="/close" element={<Close />} />
        <Route path="/login" element={<Login />} />
        <Route path='/cp' element={
          <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
        }/>
      </Routes>
    </BrowserRouter>
    </idContext.Provider>
  );
}

export default App;
